module.exports = __webpack_public_path__ + "img/delete_temp.9b56f95c.svg";